import { Mic, Sparkles, Layers, ArrowRight, Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SynapseStepProps {
  onTrySynapse: () => void;
}

export function SynapseStep({ onTrySynapse: _onTrySynapse }: SynapseStepProps) {
  const { t } = useTranslation();
  void _onTrySynapse; // Used by parent via footer button

  const PIPELINE = [
    {
      icon: Mic,
      iconColor: 'text-blue-400',
      title: t('onboarding.synapse_capture'),
      description: t('onboarding.synapse_capture_desc'),
      borderColor: '#1a2a3d',
    },
    {
      icon: Sparkles,
      iconColor: 'text-amber-400',
      title: t('onboarding.synapse_structure'),
      description: t('onboarding.synapse_structure_desc'),
      borderColor: '#3d2a14',
    },
    {
      icon: Layers,
      iconColor: 'text-violet-400',
      title: t('onboarding.synapse_project'),
      description: t('onboarding.synapse_project_desc'),
      borderColor: '#2e1a47',
    },
  ];

  return (
    <div>
      <h2 className="text-2xl font-bold text-zinc-100">{t('onboarding.synapse_step_title')}</h2>
      <p className="text-sm text-zinc-400 mt-2">{t('onboarding.synapse_step_description')}</p>

      <div className="flex flex-col sm:flex-row items-stretch gap-3 mt-8">
        {PIPELINE.map((step, i) => (
          <div key={step.title} className="contents">
            <div
              className="bg-zinc-800/60 border rounded-xl p-5 hover:border-violet-500/30 transition-colors"
              style={{
                flex: 1,
                borderColor: step.borderColor,
                animation: 'onboarding-card-in 400ms ease-out both',
                animationDelay: `${i * 100}ms`,
              }}
            >
              <step.icon className={`w-8 h-8 ${step.iconColor}`} />
              <h3 className="text-sm font-semibold text-zinc-100 mt-3">{step.title}</h3>
              <p className="text-xs text-zinc-400 mt-1">{step.description}</p>
            </div>
            {i < PIPELINE.length - 1 && (
              <div className="hidden sm:flex items-center">
                <ArrowRight className="w-5 h-5 text-zinc-600" />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="bg-violet-500/5 border-l-2 border-violet-500/40 rounded-r-lg px-4 py-3 mt-6 flex items-start gap-2">
        <Zap className="w-4 h-4 text-violet-400 mt-0.5 shrink-0" />
        <p className="text-xs text-zinc-400">{t('onboarding.synapse_credits_info')}</p>
      </div>
    </div>
  );
}
